import { Button, Menu, Fade, MenuItem, List, ListItemButton, ListItemText, ListItem, ListItemIcon } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import { signOut } from "../../features/account/accountSlice";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { clearBasket } from "../../features/basket/basketSlice";
import { Link } from "react-router-dom";
import ListAltIcon from '@mui/icons-material/ListAlt';
import LogoutIcon from '@mui/icons-material/Logout';


interface SignedInMenuProps {
    showOnly?: string[];
    variant?: string;
}

export default function SignedInMenu({ showOnly, variant }: SignedInMenuProps) {
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.account);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // create an array of menu items with their props and text
    let menuItems = [
        {
            component: Link,
            to: "/orders",
            onClick: handleClose,
            text: "My orders",
        },
        {
            onClick: () => {
                dispatch(signOut());
                dispatch(clearBasket());
            },
            text: "Logout",
        },
    ];

    // filter menuItems if showOnly prop is provided
    if (showOnly) {
        menuItems = menuItems.filter((item) => showOnly.includes(item.text));
    }

    return (
        <>
          {/* add a condition here to show or hide the button based on the variant prop */}
          {variant === 'button' && (
            <Button color="inherit" onClick={handleClick} sx={{ typography: "h6", border: "1px solid black", boxShadow: "2px 2px 4px gray" }}>
                {user?.username}
                <ArrowDropDownIcon />
            </Button>
          )}
          {/* show or hide the menu based on the variant prop */}
          {variant === 'button' && (
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} TransitionComponent={Fade}>
                {/* map the menu items array to MenuItem components */}
                {menuItems.map((item) => (
                    <MenuItem key={item.text} {...item}>
                        {item.text}
                    </MenuItem>
                ))}
            </Menu>
          )}
          {/* show or hide the list based on the variant prop */}
          {variant === 'list' && (
            <List >
              {/* map the menu items array to ListItem components */}
              {menuItems.map((item) => (
                <ListItem key={item.text} {...item}>
                  {/* render the icon based on the item text */}
                  <ListItemIcon>
                    {item.text === 'Logout' ? <LogoutIcon /> : <ListAltIcon />}
                  </ListItemIcon>
                  <ListItemButton sx={{ textAlign: 'center' }}>
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          )}
        </>
    );
}
